import {
  impressionAdvertising,
  getAdvertising, clickAdvertising, advertisementSearch,
  advertisementTopOfSearch
} from '@/apis/advertising';
import { ADVERTISING } from '../mutation-types';

export const state = {
  advertisingImpressionHistory: '',
  advertising: [],
  advertisementSearch: [],
  advertisementTopOfSearch: [],
};

export const getters = {
  advertising: state => state.advertising,
  advertisementSearch: state => state.advertisementSearch,
  advertisementTopOfSearch: state => state.advertisementTopOfSearch
};

export const mutations = {
  [ADVERTISING.ADVERTISING_IMPRESSION_HISTORY](state, data) {
    if (!data.error) {
      state.advertisingImpressionHistory = data;
    }
  },

  [ADVERTISING.GET_ADVERTISING](state, data) {
    if (!data.error) {
      state.advertising = [];
      Object.keys(data.first_view).forEach((firstViewKey) => {
        state.advertising.push(data.first_view[firstViewKey]);
      });
      Object.keys(data.slide_view).forEach((slideViewKey) => {
        state.advertising.push(data.slide_view[slideViewKey]);
      });
    }
  },

  [ADVERTISING.GET_ADVERTISEMENT_SEARCH](state, data) {
    if (!data.error) {
      state.advertisementSearch = [];
      Object.keys(data.first_view).forEach((firstViewKey) => {
        state.advertisementSearch.push(data.first_view[firstViewKey]);
      });
      Object.keys(data.slide_view).forEach((slideViewKey) => {
        state.advertisementSearch.push(data.slide_view[slideViewKey]);
      });
    }
  },

  [ADVERTISING.GET_ADVERTISEMENT_TOP_OF_SEARCH](state, data) {
    if (!data.error) {
      state.advertisementTopOfSearch = data;
    }
  }
};

export const actions = {
  async impressionAdvertising({ commit }, payload) {
    const res = await impressionAdvertising(payload);
    commit(ADVERTISING.ADVERTISING_IMPRESSION_HISTORY, res);
  },

  async getAdvertising({ commit }) {
    const res = await getAdvertising();
    commit(ADVERTISING.GET_ADVERTISING, res);
  },

  async clickAdvertising({ commit }, payload) {
    const res = await clickAdvertising(payload);

    return res;
  },

  async advertisementSearch({ commit }) {
    const res = await advertisementSearch();
    commit(ADVERTISING.GET_ADVERTISEMENT_SEARCH, res);
  },

  async advertisementTopOfSearch({ commit }) {
    const res = await advertisementTopOfSearch();
    commit(ADVERTISING.GET_ADVERTISEMENT_TOP_OF_SEARCH, res);
  }

};
